import {IonIcon} from "react-ion-icon";
import ListValue from "../displayComponents/ListValue";
import useFetch from "../../tools/UseFetch";

const TmsInGrid = props => {

    const record = props.record
    const authors = props.authors

    const minutes = (record.TimeSpentIn - 60 * Math.floor(record.TimeSpentIn / 60)).toString().padStart(2, '0')
    const hours = Math.floor(record.TimeSpentIn / 60)

    const TimeStr = (minutes === 0) ? hours + " h" : hours + ":" + minutes

    //console.log(record)



    return(

        <>

            <div className="tms-in-grid" onClick={() => props.edit(record)}>

                <h2>{record.Date.toLocaleDateString('cs-CZ')}</h2>
                <h2><ListValue listData={authors} dataID={record.AuthorID} /></h2>
                {/*<div className="tms-in-grid-info">{record.Project}</div>*/}
                <div className="tms-in-grid-info">{record.Note}</div>
                {/*<div className="tms-in-grid-info">*/}
                {/*    <span className="font-red">IN: {record.PriceIn} {record.CurrencyIn}</span>*/}
                {/*    <span className="font-green">OUT: {record.PriceOut} {record.CurrencyIn}</span>*/}
                {/*</div>*/}
                <div className="tms-in-grid-info-price">{TimeStr}</div>

            </div>

        </>
    )
}

export default TmsInGrid